module.exports = __webpack_public_path__ + "img/icon-google-play.bcb22c6e.svg";